import '@/styles/globals.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import Head from 'next/head'
import { Cormorant_Garamond, Geist_Mono, Jost } from 'next/font/google'
import { BagProvider } from '@/components/generals/bag-provider'

const sans = Jost({
    subsets: ['latin']
})

const heading = Cormorant_Garamond({
    subsets: ['latin'],
    style: ['normal', 'italic']
})

const mono = Geist_Mono({
    subsets: ['latin'],
    preload: false
})

const fontVariables = `:root{--font-app-sans:${sans.style.fontFamily};--font-app-mono:${mono.style.fontFamily};--font-app-heading:${heading.style.fontFamily}}`

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <div className='h-full font-sans'>
            <Head>
                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
            </Head>

            <BagProvider>
                <Component {...pageProps} />
            </BagProvider>
        </div>
    )
}

export default App
